import Markdown from "components/markdown";
import { FunctionComponent } from "react";
import { StyledInstructions } from "./instructions.styles";

interface ListEntityInstructionsProps {
  children: string;
}

const ListEntityInstructions: FunctionComponent<
  ListEntityInstructionsProps
> = ({ children }) => {
  return (
    <StyledInstructions>
      <Markdown>{children}</Markdown>
    </StyledInstructions>
  );
};

export default ListEntityInstructions;
